import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  InputSignal,
  model,
  ModelSignal,
  OnInit,
  Signal,
  viewChild
} from '@angular/core';
import {NgClass} from "@angular/common";
import {fallbackValidation} from "../../../../shared/util/fallbackValidation";
import {toNumber} from "../../../../shared/util/toNumber";
import {inRange} from "../../../../shared/util/inRange";
import {Transformer} from "../../../../shared/util/types/transformer";
import {notEmpty} from "../../../../shared/util/notEmpty";
import {environment} from "../../../../../environments/environment.dev";

@Component({
  selector: 'app-spacing',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './assembly-spacing.component.html',
  styles:  ":host{ @apply w-full grid grid-flow-row auto-rows-min relative;  }"
})
export class AssemblySpacingComponent implements OnInit {
  private elementRef: ElementRef= inject(ElementRef);
  private numberInputValidation: Transformer<string, number>;
  private spacingInput: Signal<ElementRef<HTMLInputElement>> = viewChild('spanInput')

  /**
   * Input model of spacing component, store creates this object on parent component
   * initialized with default values
   */
  public spacingValues: ModelSignal<any> = model()

  protected maxSpan = computed(() => this.spacingValues()?.overflowSpace ? environment.FRAME_OVERFLOW_SPACE : environment.FRAME_MAX_SPAN);

  protected minSpan = computed(() => this.spacingValues()?.overflowSpace ? 0 : environment.FRAME_MIN_SPAN);

  public relativeWidth: InputSignal<number> = input(0);

  public spacingIdx: InputSignal<number> = input(0);

  constructor() {
    this.watchSpacingValue();
  }

  ngOnInit() {
    this.numberInputValidation = fallbackValidation<string, number>(
        this.spacingValues().span,
        ()=>{},
        notEmpty,
        toNumber,
        inRange(this.spacingValues().minSpan, this.spacingValues().overflowSpace ? this.spacingValues().maxSpan : Number.MAX_SAFE_INTEGER)
    );
  }

  /**
   * Set the display and width of the host element depending on the input values
   */
  private watchSpacingValue() {
    effect(() => { this.elementRef.nativeElement.style.width = this.relativeWidth() + 'px'; });
  };

}
